import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../App.context';
import { Db } from '../../../services/Db';
import { useFavorites } from '../../../views/favorite/Favorite.hooks';

export function useLoadData(): Data {
	const { db } = useContext(AppContext);
	const [isLoaded, setIsLoaded] = useState(false);
	const [articles, setArticles] = useState<Array<any>>([]);
	const { favorites, setFavorites } = useFavorites();

	useEffect(() => {
		if (!db) {
			return;
		}

		if (isLoaded) {
			return;
		}

		if (!favorites) {
			return;
		}

		filterFavorites({
			db,
			favorites,
		})
			.then((result: FilterResponse) => {
				const favs = result.favorites;
				const articleMap = result.articleMap;
				setFavorites(favs);
				setArticles(
					[...favs]
						.map((id) => articleMap.get(id))
						.filter((i) => !!i),
				);
			})
			.catch(alert)
			.finally(() => {
				setIsLoaded(true);
			});
	}, [favorites]);
	return {
		isLoaded,
		articles,
	};
}

interface Data {
	isLoaded: boolean;
	articles: Array<any>;
}

async function filterFavorites(args: FilterOptions): Promise<FilterResponse> {
	const { favorites, db } = args;
	const articleMap = new Map<number, any>();
	const data = new Set<number>([]);
	for (const id of [...favorites]) {
		try {
			const article = await db.getArticle(`${id}`);
			if (!article) {
				continue;
			}
			const style = await db.getStyle(`${article?.style}`);
			if (!style) {
				continue;
			}
			articleMap.set(id, article);
			data.add(id);
		} catch (e) {
			continue;
		}
	}
	return {
		favorites: data,
		articleMap,
	};
}

interface FilterOptions {
	favorites: Set<number>;
	db: Db;
}

interface FilterResponse {
	favorites: Set<number>;
	articleMap: Map<number, any>;
}
